// Generado desde design-system/components/core/Glass.tsx — no editar; edita el .ts/.tsx y corre build-ds.
import { forwardRef, useCallback } from 'react';
import { cn } from '../../lib/cn';
const PAD = { none: '', sm: 'p-4', md: 'p-5 md:p-6', lg: 'p-6 md:p-8' };
export const EDGE_CLASSES = {
    pos: 'db-edge db-edge-pos',
    neg: 'db-edge db-edge-neg',
    warn: 'db-edge db-edge-warn',
    accent: 'db-edge db-edge-accent',
    signal: 'db-edge db-edge-signal',
};
/**
 * Glass — material para CONTENEDORES de información (tarjetas, paneles, KPIs,
 * tablas, navegación, modales). Nunca para controles (eso es Relief/Sunken).
 * Máx. 2 niveles anidados. Necesita color detrás (aurora o contenido).
 */
export const Glass = forwardRef(function Glass({ as, strength = 'default', spec = false, padding = 'md', edge, className, onPointerMove, children, ...rest }, ref) {
    const Tag = (as ?? 'div');
    const handleMove = useCallback((e) => {
        if (spec) {
            const r = e.currentTarget.getBoundingClientRect();
            e.currentTarget.style.setProperty('--mx', `${e.clientX - r.left}px`);
            e.currentTarget.style.setProperty('--my', `${e.clientY - r.top}px`);
        }
        onPointerMove?.(e);
    }, [spec, onPointerMove]);
    const pad = padding in PAD ? PAD[padding] : padding;
    return (<Tag ref={ref} className={cn(strength === 'strong' ? 'db-glass-strong' : 'db-glass', spec && 'db-spec', edge && EDGE_CLASSES[edge], pad, className)} onPointerMove={spec || onPointerMove ? handleMove : undefined} {...rest}>
      {children}
    </Tag>);
});
/** Relief — neumorfismo elevado para controles en reposo y superficies táctiles. */
export const Relief = forwardRef(function Relief({ as, size = 'sm', className, children, ...rest }, ref) {
    const Tag = (as ?? 'div');
    return (<Tag ref={ref} className={cn(size === 'lg' ? 'db-relief-lg' : 'db-relief', className)} {...rest}>
      {children}
    </Tag>);
});
/** Sunken — neumorfismo hundido, SOLO para campos donde se escribe o se elige un valor. Rieles y celdas: db-track. */
export const Sunken = forwardRef(function Sunken({ as, size = 'sm', className, children, ...rest }, ref) {
    const Tag = (as ?? 'div');
    return (<Tag ref={ref} className={cn(size === 'lg' ? 'db-sunken-lg' : 'db-sunken', className)} {...rest}>
      {children}
    </Tag>);
});
/** Lienzo con fondo vivo (aurora + puntos). Úsalo una vez por página/área. */
export function Canvas({ as, aurora = true, dots = true, className, children, ...rest }) {
    const Tag = (as ?? 'div');
    return (<Tag className={cn('db-canvas', className)} {...rest}>
      {aurora && (<div className="db-aurora" aria-hidden="true">
          <i />
          <i />
          <i />
        </div>)}
      {dots && <div className="db-dots" aria-hidden="true"/>}
      {children}
    </Tag>);
}
